import { Injectable, inject } from '@angular/core';
import { Theme } from '@support/models/theme.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { INITIAL_THEME } from '../constants/themes';
import { LocalStorageService } from './local-storage.service';

export const THEME_KEY = 'THEME';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private localStorageService = inject(LocalStorageService);

  private themeStateBehaviorSubject = new BehaviorSubject<Theme>(
    this.localStorageService.getItem(THEME_KEY) || INITIAL_THEME
  );

  get selectedTheme(): Observable<Theme> {
    return this.themeStateBehaviorSubject.asObservable();
  }

  changeTheme(newTheme: Theme) {
    this.localStorageService.setItem(THEME_KEY, newTheme);
    this.themeStateBehaviorSubject.next(newTheme);
  }
}
